export const normalizePhone = (phone: string): string => {
  if (!phone) return '';
  
  // 1. Удаляем всё, кроме цифр.
  let digits = phone.replace(/\D/g, '');

  // 2. Если номер начинается с 8 и его длина 11 цифр,
  // то считаем это российским номером и заменяем 8 на 7.
  if (digits.startsWith('8') && digits.length === 11) {
    digits = '7' + digits.slice(1);
  }

  // 3. Если в номере 10 цифр, считаем его российским и добавляем 7 в начало.
  if (digits.startsWith('9') && digits.length === 10) {
    digits = '7' + digits;
  }

  // 3. Если номер начинается с 375 или 374, и это 12 или 11 цифр соответственно,
  // то это уже полные номера.
  // Если же пользователь ввел что-то вроде "375 (33) 302-66-60", то digits будет "375333026660" (12 цифр).
  
  // Если строка начиналась с "+", но в digits его нет, просто добавляем.
  // В ТЗ сказано: Фронтенд работает строго с "+" и код страны в начале.
  
  // Дополнительно: если номер начинается с цифр кода страны без плюса,
  // мы просто добавляем плюс.
  // Пример: "375 (33)30266-60" -> "+375333026660"
  
  return `+${digits}`;
};
